module.exports = __webpack_public_path__ + "img/3x3-Basketball.88b90dbe.png";